import React, {Fragment} from 'react';
import {fileUpload, postData} from "../../utils/request";
import Dropzone from "react-dropzone";
import {loadComponentById} from "../../utils/components";
import {Tooltip} from "react-tippy";
import Icon from "./Icon";
import classNames from 'classnames';
import Button from "./Button";

const image = (props) => {
    const T = props.filename ? Tooltip : "div";
    return <T html={props.filename}>
        <div className={classNames("image", {[props.ext]: true})}>
            <img src={props.path + props.filename} alt={props.filename} />
            <Icon lib="fas" name="file"/>
            <span className="filename">{props.filename}</span>
            <span className="name">{props.name}</span>
            <span className="ext">{props.ext}</span>
        </div>
    </T>
};

const TYPES = {
    unknown: (props) => {
        const T = props.filename ? Tooltip : "div";
        return <T html={props.filename}>
            <div className="unknown">
                <Icon lib="fas" name="file"/>
                <span className="filename">{props.filename}</span>
                <span className="name">{props.name}</span>
                <span className="ext">{props.ext}</span>
            </div>
        </T>
    },
    jpg: image,
    jpeg: image,
    png: image,
    gif: image,
};

export default class DocumentInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.values[this.props.name] || null,
            isLoading: !this.props.values[this.props.name]
        }
    }

    componentDidMount() {
        this.loadValues();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.values[this.props.componentConfig.idfield] !== prevProps.values[prevProps.componentConfig.idfield]) {
            this.loadValues();
        }
    }

    loadValues = () => {
        if (this.props.values[this.props.name]) {
            this.setState({data: this.props.values[this.props.name]});
        } else {
            this.setState({isLoading: true}, () => {
                this.request && this.request.abort();
                this.request = loadComponentById(this.props.componentConfig.componentname, this.props.values[this.props.componentConfig.idfield], [this.props.name]);
                this.request.then((data) => {
                    this.setState({isLoading: false, data: data[this.props.name]});
                });
                this.request.catch(() => {
                    this.setState({isLoading: false, data: null});
                })
            });
        }
    }

    onDrop = async (acceptedFiles) => {
        if (!(this.props.isUploadable === undefined || this.props.isUploadable !== false)) return;
        if (this.state.isLoading || !this.props.values[this.props.componentConfig.idfield]) return;
        this.setState({isLoading: true}, async () => {
            try {
                const response = await fileUpload({
                    action: "Document.create",
                    uploaded_file: acceptedFiles[0],
                    data: {
                        field: this.props.name,
                        component: this.props.componentConfig.componentname,
                        component_id: this.props.values[this.props.componentConfig.idfield]
                    }
                });
                if (this.props.saveChanges) {
                    this.props.saveChanges(this.props.name, response.data);
                }
                this.setState({data: response.data, isLoading: false});
            } catch (e) {
                console.error(e);
                this.setState({isLoading: false});
            }
        });
    }

    openDialog = () => {
        if (!(this.props.isUploadable === undefined || this.props.isUploadable !== false)) return;
        if (this.state.isLoading || !this.props.values[this.props.componentConfig.idfield]) return;
        if (this.dropzoneRef) {
            this.dropzoneRef.open();
        }
    }

    render() {
        let style = {};
        if (this.props.label === false) {
            style.display = "none";
        }
        const filename = ((this.state.data || {}).filename || "");
        let name = filename.split(".");
        const ext = name.pop().toLowerCase();
        name = name.join(".");
        let Type = TYPES[ext] || TYPES.unknown;
        const path = ((this.state.data || {}).path || "");

        const disabled = this.state.isLoading || !filename || !this.props.values[this.props.componentConfig.idfield];

        return (
            <Fragment>
                <label htmlFor={this.props.name} className="control-label" style={style}>{this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}</label>
                <div className="document-input-holder">
                    <div className="col-md-12">
                        <Dropzone disableClick className={classNames("document-input row", {"isUploadable": (this.props.isUploadable === undefined || this.props.isUploadable !== false), [ext]: true, "loading": this.state.isLoading, "not-allowed": !this.props.values[this.props.componentConfig.idfield]})} ref={(node) => { this.dropzoneRef = node; }} onDrop={this.onDrop}>
                            <div onClick={this.openDialog} className="col-md-12">
                                <Type filename={filename} name={name} ext={ext} path={path} />
                            </div>
                        </Dropzone>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row">
                                    <Button size="xs" block={true} color="danger" disabled={disabled || !(this.props.isClearable === undefined || this.props.isClearable !== false)} onClick={() => {
                                        if (disabled) return;
                                        if (!(this.props.isClearable === undefined || this.props.isClearable !== false)) return;
                                        this.setState({isLoading: true}, async () => {
                                            const response = await postData({
                                                action: this.props.componentConfig.componentname + ".update",
                                                view: [this.props.name],
                                                data: {
                                                    [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                                                    [this.props.name]: null
                                                }
                                            });
                                            this.setState({isLoading: false, data: response.data});
                                        });
                                    }}>
                                        <Icon lib="fa" name="trash"/>
                                    </Button>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <Button tag="a" size="xs" block={true} color="default" disabled={disabled} href={path + filename} target="_blank">
                                        <Icon lib="fa" name="download"/>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}